import { Button, Col, Collapse, Row } from 'antd'
import { createSearchParams, useNavigate } from 'react-router-dom'
import LogoEvent from 'src/assets/images/logo_show.png'
import BackgroundVideo from 'src/assets/images/MELODY_SHOW.mp4'
import BannerEvent1 from 'src/assets/images/banner_show_1.jpg'
import BannerEvent2 from 'src/assets/images/banner_show_2.jpg'
import { Icon } from 'src/components/common/icons'
import { TICKET_ENUM } from 'src/services/api/constant'

const { Panel } = Collapse
export const Home = () => {
  // const { data } = useAuth()

  const navigate = useNavigate()
  const showLoginModal = () => {
    window.dispatchEvent(new Event('OpenModalLogin'))
  }

  const handleClickBuyTicket = (eventId) => {
    const token = localStorage.getItem('access_token')
    if (!token) {
      showLoginModal()
      return
    }
    navigate({
      pathname: '/buy-ticket',
      search: createSearchParams({
        ticketId: eventId,
      }).toString(),
    })
  }

  return (
    <>
      <div className="relative">
        <video
          className="w-full h-auto"
          src={BackgroundVideo}
          autoPlay
          loop
          muted
        />
      </div>
      <div className="w-full mt-4 mb-2">
        <h2 className="text-4xl text-center">ĐÃ CHÍNH THỨC MỞ BÁN VÉ</h2>
      </div>
      <Row className="relative pl-12 pr-12 order-event-banner">
        <img
          src={LogoEvent}
          alt="Logo Event"
          className="m-auto w-full max-w-[400px]"
        />
      </Row>
      <Row className="pl-12 pr-12 flex mt-4">
        <Col className="order-event-info" lg={10} xs={24}>
          <div className="event-info p-8 h-[400px]">
            <h2 className="text-4xl font-normal mb-2">Melody show 1/5</h2>

            <h2
              className="text-4xl font-normal mb-4"
              style={{ fontFamily: 'SVN-Aguda, sans-serif' }}
            >
              Hoài Niệm
            </h2>
            <div className="flex justify-left text-[#00aeef] text-[16px]">
              <p className="leading-[22px]">
                <Icon name="time" className="mr-2 w-[17px] inline-flex" />
                20H00 - 01/05/2025
              </p>
            </div>
            <div className="flex mt-4 text-[16px] leading-[20px]">
              <Icon name="address" className="mr-2 w-[17px]" />
              <p className="text-[#00aeef]">
                SÂN KHẤU THUỶ ĐÌNH
                <br />
                <span className="text-white text-[14px] inline mt-4">
                  PHỐ CỔ HOA LƯ, ĐƯỜNG TRẦN HƯNG ĐẠO, TP HOA LƯ
                </span>
              </p>
            </div>
            <div className="border-t border-solid w-full border-white mt-8">
              <p className="mt-4 font-light">
                Giá vé:{' '}
                <span className="text-[#00aeef] text-[16px]">
                  399k - 599k - 699k - 899k - 1099k - 1299k - 1499k - 7 999
                  combo 4 vé vip
                </span>
              </p>
              <Button
                onClick={() => handleClickBuyTicket(TICKET_ENUM.DAY_1)}
                className="w-full mt-4 bg-[#616466] h-[36px] border-none text-white text-lg"
              >
                Đặt vé
              </Button>
            </div>
          </div>
        </Col>
        <Col className="order-event-banner" lg={14} xs={24}>
          <img
            src={BannerEvent1}
            alt="Banner Event"
            className="w-full h-[400px] event-banner"
          />
        </Col>
      </Row>

      {/* <Row className="pl-12 pr-12 flex mt-12">
        <Col className="order-event-info" lg={10} xs={24}>
          <div className="event-info p-8 h-[400px]">
            <h2 className="text-4xl font-normal mb-2">Melody show 2/5</h2>
            <h2
              className="text-4xl font-normal mb-4"
              style={{ fontFamily: 'SVN-Aguda, sans-serif' }}
            >
              Thăng Hoa
            </h2>
            <div className="flex justify-left text-[#00aeef] text-[16px]">
              <p className="leading-[22px]">
                <Icon name="time" className="mr-2 w-[17px] inline-flex" />
                20H00 - 02/05/2025
              </p>
            </div>
            <div className="flex mt-4 text-[16px] leading-[20px]">
              <Icon name="address" className="mr-2 w-[17px]" />
              <p className="text-[#00aeef]">
                SÂN KHẤU THUỶ ĐÌNH
                <br />
                <span className="text-white text-[14px] inline mt-4">
                  PHỐ CỔ HOA LƯ, ĐƯỜNG TRẦN HƯNG ĐẠO, TP HOA LƯ
                </span>
              </p>
            </div>
            <div className="border-t border-solid w-full border-white mt-8">
              <p className="mt-4 font-light">
                Giá vé:{' '}
                <span className="text-[#00aeef] text-[16px]">
                  399k - 599k - 699k - 899k - 1099k - 1299k - 1499k - 7 999 combo 4 vé vip
                </span>
              </p>
              <Button
                onClick={() => handleClickBuyTicket(TICKET_ENUM.DAY_2)}
                className="w-full mt-4 bg-[#616466] h-[36px] border-none text-white text-lg"
              >
                Đặt vé
              </Button>
            </div>
          </div>
        </Col>
        <Col className="order-event-banner" lg={14} xs={24}>
          <img
            src={BannerEvent2}
            alt="Banner Event"
            className="w-full h-[400px] event-banner"
          />
        </Col>
      </Row> */}

      <Row gutter={[24, 24]} className="mt-8 pl-12 pr-12">
        <Col lg={8} xs={24} className="">
          <Collapse className="bg-white text-md font-bold">
            <Panel header="QUY ĐỊNH CHUNG" key="1">
              <p>
                ❌ Người tham dự không được phép mang các loại vũ khí dưới bất
                kỳ hình thức nào như đèn pin, laser, các vật sắc nhọn, viết, ô
                dù. Các loại động vật, thú nuôi. Các vật dụng dễ gây cháy nổ
                (bật lửa, nến, pháo bông, rượu, nước hoa, xăng dầu,... và tất cả
                các chất phát nổ). Không mang nước, thức ăn, ghế ngồi cá nhân từ
                bên ngoài (có rất nhiều gian hàng ẩm thực phục vụ người tham dự
                bên trong khu vực sự kiện).
              </p>
              <p className="mt-2">
                ❌ Tuyệt đối tuân thủ quy định của BTC và hướng dẫn của đội ngũ
                an ninh. Trong trường hợp Người tham dự có hành động quá khích,
                kích động đám đông, tự ý di chuyển vào khu vực sân khấu, khu vực
                cấm,.... BTC có quyền yêu cầu người vi phạm ra khỏi khu vực sự
                kiện (hoặc nhờ cơ quan chức năng can thiệp) và không hoàn trả
                lại vé.
              </p>
              <p className="mt-2">
                ❌ Không phá hoại, gây thiệt hại hay trộm cắp bất kì tài sản nào
                trông khuôn viên sự kiện (trường hợp vi phạm sẽ bị xử phạt theo
                quy định)
              </p>
              <p className="mt-2">
                ❌ Vui lòng ngồi/ đứng đúng khu vực ghi trên vé.
              </p>
              <p className="mt-2">
                ❌ Người tham dự đồng ý ủy quyền cho BTC/ Nhân viên y tế/ An
                ninh/ người đại diện giúp vận chuyển Người tham dự đến các cơ sở
                y tế để chữa trị (có thể bao gồm sơ tán, nhập viện, truyền máu,
                phẫu thuật và cấp thuốc). Người tham dự chi trả toàn bộ chi phí
                liên quan đến việc chăm sóc và điều trị của Sở y tế (nếu có).
              </p>
              <p className="mt-2">
                ❌ Người tham dự tự bảo quản tài sản cá nhân khi tham gia Chương
                trình.
              </p>
              <p className="mt-2">
                ❌ Trong mọi trường hợp, quyết định của BTC là quyết định cuối
                cùng.
              </p>
            </Panel>
          </Collapse>
        </Col>
        <Col lg={8} xs={24} className="">
          <Collapse className="bg-white text-md font-bold">
            <Panel header="QUY ĐỊNH ĐẶT VÉ" key="2">
              <p>
                ✅ Người tham dự tự cân nhắc và chịu trách nhiệm về sức khoẻ của
                mình khi mua vé để tham gia chương trình.
              </p>
              <p className="mt-2">
                ✅ Người tham dự đăng chỉ ký tài khoản tại link web bán vé mà
                Fanpage Sắc Việt Event cung cấp.
              </p>
              <p className="mt-2">
                ✅ Đối với hạng vé ngồi: Người tham dự đủ từ 12 tuổi trở lên
                không cần người giám hộ. Người tham dự từ 5 tuổi đến 11 tuổi
                phải có người giám hộ đi kèm (người giám hộ phải đủ từ 18 tuổi
                trở lên).
              </p>
              <p className="mt-2">
                ✅ Đối với hạng vé đứng: Người tham dự đủ từ 12 tuổi trở lên
                được tham dự chương trình và không cần người giám hộ.
              </p>
              <p className="mt-2">
                ✅ Phụ nữ mang thai chỉ được mua hạng vé ngồi và phải đảm bảo và
                chịu trách nhiệm về sức khoẻ của mình khi tham gia chương trình.
              </p>
              <p className="mt-2">
                ✅ Một tài khoản được mua tối đa 4 vé. Mỗi vé chỉ dành cho 01
                người tham dự, không kèm trẻ em và vị thành niên. Người giám hộ
                đi kèm vị thanh niên phải mua vé để tham dự.Người tham dự có
                trách nhiệm tự bảo mật thông tin mã vé của mình
              </p>
              <p className="mt-2">
                ✅ Vé đã mua không đổi/ trả dưới mọi hình thức, trừ trường hợp
                chương trình bị huỷ hoặc hoãn do phía BTC. Trong trường hợp bị
                huỷ hoặc hoãn lý do bất khả kháng (thiên tai, lũ lụt, dịch
                bệnh,…) BTC sẽ triển khai chương trình vào thời gian sau đó và
                vé được bảo lưu sử dụng.
              </p>
            </Panel>
          </Collapse>
        </Col>
        <Col lg={8} xs={24} className="">
          <Collapse className="bg-white text-md font-bold">
            <Panel header="QUY ĐỊNH CHECK-IN" key="3">
              <p>
                ✅ Người tham dự có mặt tại khu vực check-in từ 17h00 đến 20h00.
                Từ 20h01 – 20h29 làm thủ tục check-in bổ sung. Cửa check-in sẽ
                đóng cửa vào 20h30. Đối với trường hợp làm thủ tục sau 20h30 của
                ngày diễn ra chương trình, sẽ không được phép tham gia chương
                trình và không được hoàn trả tiền vé.
              </p>
              <p className="mt-2">
                ✅ Người tham dự làm thủ tục check-in đúng khu vực do BTC quy
                định.
              </p>
              <p className="mt-2">
                ✅ Mỗi mã vé điện tử chỉ có giá trị cho 01 (một) người và 01
                (một) lần sử dụng. Chỉ người đầu tiên quét mã vé được phép tham
                gia sự kiện. Trường hợp có nhiều hơn 01 (một) người check-in
                cùng một mã vé, BTC sẽ không chịu trách nhiệm và từ chối giải
                quyết.
              </p>
              <p className="mt-2">
                ✅ Khi làm thủ tục check-in, người tham dự sẽ nhận được vòng đeo
                tay tương ứng với khu vực vé mà mình đã mua. Người tham dự có
                trách nhiệm giữ vòng tay xuyên suốt chương trình (lực lượng bảo
                an của BTC sẽ kiểm tra liên tục, nếu Người tham dự làm mất vòng
                tay, BTC có quyền yêu cầu rời khỏi chương trình).
              </p>
              <p className="mt-2">
                ✅ Người tham dự nhận quyền lợi của hạng vé mà mình đã mua tại
                cổng check-in và kiểm tra đủ các quyền lợi trước khi rời khỏi
                khu vực check-in. BTC từ chối giải quyết trường hợp người tham
                dự đã rời khỏi khu vực check-in.
              </p>
              <p className="mt-2">
                ✅ BTC có quyền từ chối Người tham dự check-in trong trường hợp
                chưa đủ tuổi, say xỉn hoặc trạng thái mất kiểm soát hay vi phạm
                quy định của chương trình và BTC sẽ không hoàn trả tiền vé.
              </p>
            </Panel>
          </Collapse>
        </Col>
      </Row>
    </>
  )
}
